export default __webpack_public_path__ + "static/media/ribbing.1dbbb16e.jpeg";